import React, { useState, useContext, useRef, useEffect } from 'react';

/** components */
import { FileInput } from '../components/FormElements';
import Layout from '../components/common/Layout';

/** context */
import { UserContext } from '../context/UserContext';
import { useRudder } from '../hooks/rudder';
import { useForm } from '../hooks/useForm';

/** service */
import { updateApplication } from '../service/api';

const AdditionalDocs = () => {
  const { appData, updateAppData } = useContext(UserContext);
  const fileFeature = appData?.applicationFeatures?.find(
    (feature) => feature.itemType === 'FileProperty'
  );

  const { getPropertyFields } = useForm();
  const [data, setData] = useState({});
  const [dataError, setDataError] = useState({});
  const fields = getPropertyFields(fileFeature, data);

  const fileFilterOptions = ['All', 'REQUESTED', 'SUBMITTED'];
  const [fileFilter, setFileFilter] = useState('REQUESTED');
  const [filteredFields, setFilteredFields] = useState([]);

  const stateRef = useRef();
  stateRef.current = data;

  useEffect(() => {
    if (fileFeature && fileFeature.format) {
      let fileData = {};
      const originalFileTypes = Object.keys(fileFeature.format);
      fileFeature.value
        .filter((field) => !field.fileType.includes('bankVerificationStatement'))
        .map((item) => {
          if (originalFileTypes.includes(item['fileType'])) {
            // For the fields that exist under feature.format
            if (item['category']) {
              if (!fileData[item['fileType']]) {
                fileData[item['fileType']] = [];
              }
              fileData[item['fileType']].push({
                ...item,
                isProtected: item.password == 'masked' ? '1' : '0',
                password: null,
                isPwdShow: '0',
              });
            } else {
              if (!fileData[item['fileType']]) {
                fileData[item['fileType']] = [];
              }
              fileData[item['fileType']].push({
                ...item,
                isProtected: item.password == 'masked' ? '1' : '0',
                password: null,
                isPwdShow: '0',
              });
            }
          } else {
            // For the fields that only exist under feature.value
            fileData[item['fileName']] = [
              {
                ...item,
                isProtected: item.password == 'masked' ? '1' : '0',
                password: null,
                isPwdShow: '0',
              },
            ];
          }
        });
      setData(fileData);
    }
    // eslint-disable-next-line
  }, [fileFeature]);

  useEffect(() => {
    setFilteredFields(
      fields.filter((field) => {
        if (field.fileType.includes('bankVerificationStatement')) {
          return false;
        }
        const fieldValue = data[field.name];
        if (fieldValue?.length && fieldValue[0]?.status == 'WAIVED') {
          // Do not show WAIVED documents
          return false;
        }
        if (fileFilter == 'REQUESTED') {
          return (
            !fieldValue?.length ||
            fieldValue[0]?.status == 'REQUESTED' ||
            fieldValue[0]?.status == 'DECLINED'
          );
        }
        if (fileFilter == 'SUBMITTED') {
          return fieldValue?.length && fieldValue[0]?.status == 'SUBMITTED';
        }
        return true;
      })
    );
  }, [fileFilter, data, fields.length]);

  /** call updateApplication API for FileInput */
  const handleSaveFileProperty = async () => {
    setTimeout(async () => {
      // To call update API with the updated state data, delay api call
      const sanitizedData = Object.values(stateRef.current).reduce(
        (previousValue, currentValue) => [...previousValue, ...currentValue],
        []
      );

      const updatedData = await updateApplication([
        {
          itemType: fileFeature.itemType,
          dataType: fileFeature.dataType,
          name: fileFeature.name,
          value: sanitizedData.filter((item) => {
            return item.userAdded == false || item.id || (!item.error && !item.isCanceled);
          }),
        },
      ]);

      if (updatedData.data) {
        updateAppData(updatedData.data);
      }
    }, 1000);
  };

  // update files state for FileInput
  const handleSetData = (field, values) => {
    setData((data) => ({
      ...data,
      [field.name]: Array.isArray(values) ? [...values] : values,
    }));
  };

  const handleSetDataError = (field, msg) => {
    setDataError({ ...dataError, [field.name]: msg });
  };

  const initializeSectionError = () => {};

  const renderFileFilters = () => {
    return (
      <div className="file-filters">
        {fileFilterOptions.map((option) => {
          return (
            <div className={`formCustomCheckBox`} key={`filter-${option}`}>
              <label htmlFor={`filter-${option}`}>
                <input
                  id={`filter-${option}`}
                  checked={fileFilter == option}
                  name={option}
                  onChange={() => setFileFilter(option)}
                  type="checkbox"
                />
                {option}
              </label>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <Layout>
      <div className="need-docs">
        <div className="need-docs-header">
          <h1 className="title">Additional Documents Needed</h1>
          <h3 className="subtitle">
            We have most of your information. We need a few more documents in order to continue.
          </h3>
        </div>
        {renderFileFilters()}
        {filteredFields.map((field) => {
          if (!data[field.name]) {
            return;
          }
          return (
            <FileInput
              field={field}
              key={field.name}
              fieldValue={data[field.name] ?? []}
              fieldError={dataError[field.name]}
              handleSetData={handleSetData}
              handleSetDataError={handleSetDataError}
              handleSaveFileProperty={handleSaveFileProperty}
              initializeSectionError={initializeSectionError}
            />
          );
        })}
      </div>
    </Layout>
  );
};

export default AdditionalDocs;
